import * as React from "react"

import Category from "../../route/tag"





// markup
const IndexPage = (props) => {
  return (
    <React.Fragment>
      <Category props={props} />
      </React.Fragment>
  )
}

export default IndexPage
